{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-12T05:22:44.787Z","source":"place-details"}